import underscoreLite from './underscoreLite';


/**
 * Fire given callback for every element inside a nodelist, or for the given element if there's only one.
 *
 * @param {Element|HTMLElement|NodeList} nodes
 * @param {function} callback
 */
export default function(nodes, callback) {

    if (nodes instanceof NodeList) {
        underscoreLite.each(nodes, callback);
    } else {
        callback(nodes);
    }
}